<template>
  <MultipleFlows
    v-if="multi?.entities"
    flow-type="distributions"
    :entities="multi?.entities?.value"
    :restrictions="DISTRIBUTION_TYPES"
  />
  <div
    v-else
    class="wizzard__form"
  >
    <Flows
      :flows="distributions"
      :restrictions="DISTRIBUTION_TYPES"
      @submit="handleSubmit"
      @remove="handleRemove"
    />
  </div>
</template>

<script setup lang="ts">
import { inject } from 'vue'

import { TransactionClass } from '@types'

import { DISTRIBUTION_TYPES } from './utils/const'
import { MULTI_ENTITY_CONTEXT } from '../utils/const'

import Flows from './components/Flows.vue'
import MultipleFlows from './components/MultipleFlows.vue'

const distributions = defineModel<TransactionClass[]>('distributions', {
  required: true,
})

const multi = inject(MULTI_ENTITY_CONTEXT)

defineOptions({ inheritAttrs: false })

const handleSubmit = (data: TransactionClass) => {
  distributions.value?.push(data)
}

const handleRemove = (index: number) => {
  distributions.value?.splice(index, 1)
}
</script>
